/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="store_login_unit_manage_menu">企業管理者画面</div>
            <div class="admin_menu_top_unit menu_center">
                <form class="form_store">
                    <div class="lavel_store right_comment">
                        <label for="storename">店舗名</label>
                    </div>
                    <div class="input_store left_comment">
                        <label  id="storename" name="storename">{{storeContent.storeName}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storepostalcode">郵便番号</label>
                    </div>
                    <div class="input_store left_comment ">
                        <label id="storepostalcode" name="storepostalcode">{{storeContent.zipCode}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storeaddress">店舗住所</label>
                    </div>
                    <div class="input_store left_comment">
                        <label id="storeaddress" name="storeaddress">{{storeContent.address}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storeｒemarks">備考欄</label>
                    </div>
                    <div class="input_store left_comment">
                        <label id="storeｒemarks" name="storeｒemarks" >{{storeContent.remarks}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storetell">連絡先電話番号</label>
                    </div>
                    <div class="input_store left_comment">
                        <label id="storetell" name="storetell" >{{storeContent.phoneNumber}}</label>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storeanomalymail">アラート通知先</label>
                    </div>
                    <div class="input_store left_comment">
                      <div v-for="(email, index) in storeContent.anomalyMail" :key="index" class="d-flex align-items-start mgb_10">
                        <label id="storeanomalymail" name="storeanomalymail" >{{email}}</label>
                      </div>
                    </div>

                    <div class="lavel_store right_comment">
                        <label for="storperson">店舗管理者氏名</label>
                    </div>
                    <div class="input_store left_comment">
                        <label id="storperson" name="storperson">{{storeContent.adminName}}</label>
                    </div>
                </form>
                <div class="password_init">
                    <input role="button" id="arrangement4" @click="openModel" value="パスワード初期化">
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
        <div class="overlay" v-if="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">店舗管理者パスワード初期化</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>店舗管理者パスワードを初期化します。<br>
                            よろしいですか？<br>
                            店舗名：{{storeContent.storeName}}
                        </p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.stop.prevent="closeModel">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.stop.prevent="delModel">パスワード初期化</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-if="showContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">店舗管理者パスワード初期化</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>パスワード初期化が完了しました。<br>
                            新しいパスワードを店舗管理者に通知してください。<br>
                            新しいパスワード：{{password}}
                        </p>
                    </div>

                    <div class="btn_submit_box">
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="closeModel2()">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
export default {
    name: 'StoreDetail',
    components: {
        PulseLoader
    },
    data: function () {
        return {
            isLoading:false,
            isInitLoading:true,
            brandId: '',
            password: '',
            showContent: false,
            showContent2: false,
            storeContent: {}
        }
    },
    computed:{
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        id() {
            return this.$store.getters['store/selectedStoreId']
        }
    },
    created: function(){
        this.calc();
    },
    methods:{
        calc(){
            this.brandId = this.$store.getters['brand/id'];
            // 店舗情報の取得
            this.$axios
                   .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/'  + this.id )
                   .then(response => (this.storeContent = response['data']['storeData']))
                   .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);
        },
        openModel() {
            this.showContent = true;
        },
        closeModel() {
            this.showContent = false;
        },
        closeModel2() {
            this.showContent2 = false;
            this.password = ''
        },
        async delModel() {

            // 初期化
            this.showContent = false;
            this.isLoading = true;
            this.ApivalidationMessage = '';

            // APIフラグオン
            var apiResponseFlg = true;

            // パスワード初期化API
            await this.$axios
                .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/password_init', {
                    brand_id: this.brandId,
                    store_id: this.id,
                })
                .then(response => (this.password = response['data']['manager'].password))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.ApivalidationMessage =  error.message;
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            if(apiResponseFlg){
                this.showContent2 = true
            }
        },
    }
}
</script>